import forOwn from 'lodash/forOwn';

export const createQueryParams = <Entity>(entity: Entity): string => {
  const queryParams: string[] = [];
  forOwn(entity, (value: unknown, key: string) => {
    if (Array.isArray(value)) {
      forOwn(value, (childValue: unknown) => {
        if (childValue) {
          queryParams.push(`${key}=${childValue}`);
        }
      });
    } else {
      if (value !== null && value !== undefined && value !== '') {
        queryParams.push(`${key}=${value}`);
      }
    }
  });

  return queryParams.length > 0 ? '?' + queryParams.join('&') : '';
};
